let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");
let ImageURLs = require("../../utils/ImageURLs");
let SigninForm = require("./SigninForm");
let ForgotForm = require("./ForgotForm");
let AuthedUserSession = require("../../utils/AuthedUserSession");

module.exports = dd.createClass({
    getInitialState() {
        return {show_forgot_password: false};
    },
    __toggleForgotPasswordView: esUtils.wrapPreventDefault(function () {
        this.setState({show_forgot_password: !this.state.show_forgot_password});
    }),
    render() {

        let body = null;
        let footer = null;
        if (this.state.show_forgot_password) {
            body = ForgotForm();
            footer = dd.div({style: {marginTop: 10}, className: "text-center"},
                dd.a({href: "#", onClick: this.__toggleForgotPasswordView},
                    dd.i({className: "fa fa-arrow-left"}),
                    " Back to sign in"
                )
            );
        } else {
            body = SigninForm();
            footer = dd.div({style: {marginTop: 10}},
                dd.a({href: "#", className: "pull-left", onClick: this.__toggleForgotPasswordView}, "Forgot Password?"),
                !AuthedUserSession.is_privatelabel
                    ? dd.a({href: "https://www.espeakers.com/speakers/plans-pricing", className: "pull-right"},
                    "Need an account?"
                    )
                    : null,
                dd.div({className: "clearfix"})
            );
        }

        return dd.div({},
            dd.div({className: "clearfix"}),
            dd.div({style: {margin: "50px auto 0 auto", width: 300}},
                dd.div({className: "well text-center"},
                    dd.img({src: ImageURLs.logo, style: {marginBottom: 15, maxWidth: "100%"}}),
                    body,
                    footer
                ),
                AuthedUserSession.is_privatelabel
                    ? dd.footer({className: "text-muted text-center"},
                    "powered by eSpeakers"
                    )
                    : null
            )
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/signin/index.js